import { RecommendationsTitle, RecommendationsSubtitle, RecommendationsTitleTag, RecommendationsSeeMoreCard, RecommendationsSideButton, RecommendationsFooter, withCarouselContainer } from '@recommendations-fe/commons';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _jsx from '@babel/runtime/helpers/jsx';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { useRef } from 'react';
import 'prop-types';
import classNames from 'classnames';
import AndesCarouselFree, { CarouselFreeSlide } from '@andes/carousel-free';
import { namespaceRecommendations } from '@recommendations-fe/commons/namespaces';
import { jsxs, jsx } from 'react/jsx-runtime';
const _excluded = ["compact", "className", "classnameFromResponse", "classNamesMap", "classNamesIndexMap", "Card", "cardProps", "IconFactory", "paddingHorizontal", "buttonSize", "hideRebates", "onItemClick", "onBookmarkClick", "onTitleTagClick", "bookmarkedItems", "bookmarkText", "priceSizeOverride", "isPolycard"];
const namespace = "".concat(namespaceRecommendations, "-carousel-free");
const CarouselFree = _ref => {
  let {
      compact,
      className = '',
      classnameFromResponse = '',
      classNamesMap = {},
      classNamesIndexMap = {},
      Card,
      cardProps,
      IconFactory,
      paddingHorizontal = 0,
      buttonSize = 'large',
      hideRebates = false,
      onItemClick,
      onBookmarkClick,
      onTitleTagClick,
      bookmarkedItems,
      bookmarkText,
      priceSizeOverride,
      isPolycard = false
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  // Card Height Setting
  const carouselRef = useRef();

  // Misc components props
  const {
    items,
    title,
    titleWithIcons,
    titleTag,
    subtitle,
    viewMoreAction,
    footer,
    href,
    cardSeeMore = null
  } = rest;

  // Compact fontsize override
  const compactPriceSizeOverride = priceSizeOverride || {
    price: 14,
    discount: 10,
    installments: 10
  };
  return items && items.length > 0 && /*#__PURE__*/jsxs("div", {
    className: classNames(namespace, className, classnameFromResponse, {
      ["".concat(namespace, "--compact")]: compact
    }),
    ref: carouselRef,
    style: {
      '--carousel-free-padding': "".concat(paddingHorizontal, "px")
    },
    children: [title && /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__header")
    }, void 0, /*#__PURE__*/_jsx(RecommendationsTitle, {
      title: title,
      titleWithIcons: titleWithIcons,
      href: href,
      IconFactory: IconFactory
    }), subtitle && /*#__PURE__*/_jsx(RecommendationsSubtitle, {
      text: subtitle.text,
      url: subtitle.url,
      IconFactory: IconFactory,
      advertisingLabel: subtitle.advertising_label
    }), titleTag && /*#__PURE__*/_jsx(RecommendationsTitleTag, {
      text: titleTag.text,
      values: titleTag.values,
      styles: titleTag.styles,
      IconFactory: IconFactory,
      onTitleTagClick: onTitleTagClick
    })), /*#__PURE__*/_jsx(AndesCarouselFree, {
      srLabel: title,
      spacing: compact ? 0 : 12
    }, void 0, items.map((item, index) => {
      const classNameFromMap = classNamesMap[item.id];
      /* eslint-disable-next-line security/detect-object-injection */
      const classNameFromIndex = classNamesIndexMap[index];
      const CardToUse = item.CustomCard || Card;
      const id = isPolycard ? item.metadata.id : item.id;
      return /*#__PURE__*/_jsx(CarouselFreeSlide, {}, "recommendations-".concat(id), /*#__PURE__*/jsx(CardToUse, _objectSpread(_objectSpread(_objectSpread({}, cardProps), item), {}, {
        classNameFromMap: classNameFromMap,
        classNameFromIndex: classNameFromIndex,
        IconFactory: IconFactory,
        onItemClick: onItemClick,
        onBookmarkClick: onBookmarkClick,
        bookmarkedItems: bookmarkedItems,
        bookmarkText: bookmarkText,
        hideRebates: hideRebates,
        priceSizeOverride: compact ? compactPriceSizeOverride : priceSizeOverride || undefined
      })));
    }), cardSeeMore && cardSeeMore.actionText && /*#__PURE__*/_jsx(CarouselFreeSlide, {}, "recommendations-see-more", /*#__PURE__*/jsx(RecommendationsSeeMoreCard, _objectSpread({}, cardSeeMore)))), viewMoreAction && /*#__PURE__*/_jsx(RecommendationsSideButton, {
      id: viewMoreAction.id,
      target: viewMoreAction.target,
      label: viewMoreAction.label,
      buttonSize: buttonSize,
      IconFactory: IconFactory
    }), footer && /*#__PURE__*/_jsx(RecommendationsFooter, {
      footerText: footer.text,
      href: footer.link,
      IconFactory: IconFactory,
      className: viewMoreAction ? "".concat(namespaceRecommendations, "-footer--with-side-button") : ''
    })]
  });
};
CarouselFree.defaultProps = {
  lazyLoad: true
};
var RecommendationsCarouselFreeWithoutContainer = CarouselFree;
const RecommendationsCarouselFree = withCarouselContainer(RecommendationsCarouselFreeWithoutContainer);
export { RecommendationsCarouselFree, RecommendationsCarouselFreeWithoutContainer };
